import moment from 'moment'
import store from '@/store/index'
import {useStore} from '@/store/index2'
import config from '@/config'
export const getDateTime = (input) => {
  const result = moment(input).format('YYYY-MM-DD HH:mm:ss')
  return result === 'Invalid date' ? '' : result
}
export const getCompanyName = (id) => {
  const t = store.state.companyList.find(t => t.id === id)
  return t ? t.name : '--'
}
export const getCompanyById = (id) => {
  const t = store.state.companyList.find(t => t.id === id)
  return t || { name: '--' }
}
export const getTeamName = (id) => {
  const t = store.state.teamList.find(t => t.id === id)
  return t ? t.name : '--'
}
export const getRoleName = (id) => {
  const t = store.state.roleList.find(t => t.roleId === id)
  return t ? t.roleName : '--'
}
export const getDataTypeName = (id) => {
  const t = store.state.dataTypeList.find(t => t.id === id)
  return t ? t.chineseInstructions : '--'
}
export const getUserName = (id) => {
  const t = store.state.userList.find(t => t.userId === id)
  return t ? t.name : '--'
}
export const getTaskName = (id) => {
  const list = JSON.parse(localStorage.getItem('taskTypes'))
  const t = list.find(t => t.id - 0 === id - 0)
  return t ? t.chineseInstructions : '--'
}
export const getValue = (value) => {
  return value || '--'
}
export const getState = (input) => {
  return input === 'open' ? '已启用' : '已停用'
}
export const cleanParams = (params) => {
  return Object.fromEntries(Object.entries(params).filter(arr => arr[1] || arr[1] === 0))
}
export const dateFormat = (input) => {
  let output = ''
  if (input) {
    try {
      output = new Date(input).toJSON().replace('Z', '+0000')
    } catch {
      output = ''
    }
  }
  return output
}
export const getStateName = (state) => {
  const t = config.taskState.find(t => t.state === state)
  return t ? t.name : '--'
}
export const getSubStateName = (state) => {
  const t = config.subTaskState.find(t => t.state === state)
  return t ? t.name : '--'
}
export const successFailure = (input) => {
  return input === 'success' ? '是' : input === 'failure' ? '否' : '否'
}
export const successFailure2 = (input) => {
  return input === 'success' ? '有' : input === 'failure' ? '无' : '无'
}
export const statusToCn = (status, statusObj) => {
  let statusCn = ''
  if(status && statusObj){ 
    statusCn = statusObj[status]
  }
  return statusCn
}
